module.exports = __webpack_public_path__ + "img/IMG-20210520-WA0001.0772d4e3.jpg";